import React, { useState, useEffect, useMemo } from 'react';
import { Table, Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useParams } from 'react-router-dom';
import EditableContractPlayerRow from './EditableContractPlayerRow';
import Alert from 'react-bootstrap/Alert';
import SortableHeader, { sortPlayers } from './TeamTableSort';

const UnsignedPlayerSection = ({ unsigned_players, updateData, team_cap_summary}) => {
  const [showModal, setShowModal] = useState(false);
  const [editablePlayers, setEditablePlayers] = useState(unsigned_players);
  const [teamCapSummary, setTeamCapSummary] = useState(team_cap_summary);
  const [showAlert, setShowAlert] = useState(false);
  const [sort, setSort] = useState({ key: 'salary', direction: 'desc' });

  const { league_key, league_team_id } = useParams();
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const toggleSort = (key) => {
    setSort((current) => ({
      key,
      direction: current.key === key && current.direction === 'desc' ? 'asc' : 'desc',
    }));
  };

  const displayedPlayers = useMemo(
    () => sortPlayers(editablePlayers, sort),
    [editablePlayers, sort]
  );

  const handleUpdate = (newData) => {
    console.log("handleUpdate: ", newData)
    setTeamCapSummary(newData);
  }

    useEffect(() => {
        setTeamCapSummary(team_cap_summary);
    }, [team_cap_summary]);
  

  const handleSubmit = async () => {
   // Submit your changes here. `editablePlayers` contains the modified data.
    if (teamCapSummary.available_contract_years >= 0) {
        setShowAlert(false);

        try {
            // Using the environment variable here
            const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/league/confirm_keepers/${league_key}/${league_team_id}`;

            const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(editablePlayers),
            });
        
            if (response.ok) {
                console.log("Keepers confirmed")
                window.location.reload();
            } else {
            console.error("Failed to submit data:", await response.json());
            }
        } catch (error) {
            console.error("There was an error submitting the data:", error);
        }
    
        } else {
            setShowAlert(true);
        }
        
    handleClose();
  };

    useEffect(() => {
        if (unsigned_players) {
        setEditablePlayers(unsigned_players);
        }
    }, [unsigned_players]);

  return (
    
    <div className="unsigned_player_section">
        {showAlert && (
        <Alert variant="danger">
            Too many contract years are being used.
        </Alert>
        )}
      {unsigned_players?.length > 0 ? (
        <div>
          <div className="header-container">
            <h3>Unsigned contracts</h3>
            <Button onClick={handleShow}>Submit Keepers</Button>

            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to submit your contracts?</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Confirm
                </Button>
                </Modal.Footer>
            </Modal>
          </div>


          <Table responsive bordered hover className='table'>
            <thead>
              <tr>
                <SortableHeader label="Player" column="player_name" sort={sort} onSort={toggleSort} className="name-th" />
                <SortableHeader label="Salary" column="salary" sort={sort} onSort={toggleSort} />
                <SortableHeader label="Market Value" column="auction_value" sort={sort} onSort={toggleSort} />
                <SortableHeader label="Years" column="contract_length" sort={sort} onSort={toggleSort} />
              </tr>
            </thead>
            <tbody>
              {displayedPlayers.map((player_contract) => (
                <EditableContractPlayerRow
                  key={player_contract.player_key}
                  index={editablePlayers.findIndex((player) => player.player_key === player_contract.player_key)}
                  player={player_contract}
                  setEditablePlayers={setEditablePlayers}
                  editablePlayers={editablePlayers}
                  updateData={updateData}
                  handleUpdate={handleUpdate}
                />
              ))}
            </tbody>
          </Table>
          
        </div>
      ) : null}
    </div>
  );
};

export default UnsignedPlayerSection;
